export function emptyStringsToNull(obj: Record<string, any>) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      value === "" ? null : value,
    ])
  );
}

export const getNextAvailableColor = () => {
  const randomColor = `#${Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, "0")}`;
  return randomColor;
};

export const isInFeatureOrSegmentPage = (pathname: string): boolean => {
  return /\/feature-flip\/project\/\d+\/(features|segments)$/.test(pathname);
};
